import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { CommonMethodService } from '../services/common.method-service';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(private loaderService: LoaderService,private commonMethodService: CommonMethodService) { }
  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   if (this.loaderService?.activeRequests === 0) {
  //     if (!req.url.includes('authenticate/v1/token')) {
  //       this.loaderService.show();
  //     }
  //   }
  //   this.loaderService.activeRequests++;
  //   return next.handle(req).pipe(
  //     tap(
  //       (event: HttpEvent<any>) => {
  //         if (event instanceof HttpResponse) {
  //           if (!req.url.includes('authenticate/v1/token')) {
  //             this.loaderService.hideLoader();
  //           }
  //         }
  //       }),
  //     // tap({
  //     //   next: (event: HttpEvent<any>) => {
  //     //     if (event instanceof HttpResponse) {
  //     //       if (!req?.url?.includes('authenticate/v1/token')) {
  //     //         this.onEnd();
  //     //       }
  //     //     }
  //     //   },
  //     //   error: (err) =>{ 
  //     //     console.error('Error caught in Loader Interceptor',err); 
  //     //     this.onEnd();
  //     //   },
  //     //   complete: () => {
  //     //     this.onEnd();
  //     //   }
  //     // }),
  //     // finalize(()=>{
  //     //   if (!req.url.includes('authenticate/v1/token')) {
  //     //     this.onEnd();
  //     //   }
  //     // }),
  //     catchError((error:HttpErrorResponse) => {
  //       if (error.name === 'HttpErrorResponse' && error.statusText === 'cancelled') {
  //         console.error(error.statusText,'errorororororo'); 
  //       }
  //       this.loaderService.hideLoader();
  //       return  this.commonMethodService.handleError(error);
  //   })
  //     );
  // }

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const shouldShowLoader = !req.url.includes('authenticate/v1/token');

  if (shouldShowLoader && this.loaderService.activeRequests === 0) {
    this.loaderService.show();
  }

  if (shouldShowLoader) {
    this.loaderService.activeRequests++;
  }

  return next.handle(req).pipe(
    tap((event: HttpEvent<any>) => {
      // Do nothing on success — let finalize handle it
    }),
    catchError((error: HttpErrorResponse) => {
      // Optional: log or handle error here
      return this.commonMethodService.handleError(error);
    }),
    finalize(() => {
      if (shouldShowLoader) {
        this.loaderService.activeRequests = Math.max(0, this.loaderService.activeRequests - 1);
        if (this.loaderService.activeRequests === 0) {
          this.loaderService.hideLoader();
        }
      }
    })
  );
}
}
